'use client'
import React, { useEffect } from 'react'
import Header from '@/components/layout/main/header'
import Footer from '@/components/layout/main/footer/Footer'
import screen1a from '@/images/terms-conditions/terms-conditions-1a.png'
import screen1b from '@/images/terms-conditions/terms-conditions-1b.png'
import screen2a from '@/images/terms-conditions/terms-conditions-2a.png'
import screen2b from '@/images/terms-conditions/terms-conditions-2b.png'
import { ImageGallery } from './ImageGallery'
import { CheckBoxCheckedGreen } from '../../icons/CheckBoxCheckedGreen'

const studentImagesA = [
  { src: screen1a.src, width: 1600, height: 900 },
  { src: screen1b.src, width: 1600, height: 900 },
]

const studentImagesB = [
  { src: screen2a.src, width: 1600, height: 900 },
  { src: screen2b.src, width: 1600, height: 900 },
]

export default function TermsAndConditions() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <Header />
      <div className="max-w-5xl mx-auto mt-[20px] px-4 lg:px-0">
        <h3 className="font-bold text-base text-[#4849A6] leading-6 mb-[10px]">
          Terms and Conditions
        </h3>
        <div>
          <h3 className="font-bold text-base text-[#4849A6] leading-6 mb-[10px]">
            1. Introduction
          </h3>
          <p className="font-light text-base text-[#4849A6] leading-6 mb-[10px]">
            {`By accessing and using app.examsolutions.net ("the Site"), you
            agree to the following Terms and Conditions. If you do not agree to
            these terms, please do not use the Site.`}
          </p>
        </div>
        <div>
          <h3 className="font-bold text-base text-[#4849A6] leading-6 mb-[10px]">
            2. Company Information
          </h3>
          <p className="font-light text-base text-[#4849A6] leading-6 mb-[10px]">
            ExamSolutions is registered at 5 The Mall, Ealing, London, England,
            W5 2PJ with company number 12910945. ExamSolutions is owned by
            Visely Limited, with its registered office at 123 Uxbridge Road,
            Uxbridge, England, UB10 0LQ and company number 11992575.
          </p>
        </div>
        <div>
          <h3 className="font-bold text-base text-[#4849A6] leading-6 mb-[10px]">
            3. Service Offerings
          </h3>
          <p className="font-light text-base text-[#4849A6] leading-6 mb-[10px]">
            Subscriptions: ExamSolutions offers interactive courses on a
            subscription basis. The Exam Pack Subscription comes with a
            money-back guarantee, provided you set a target grade during the
            onboarding phase and complete all lessons to a satisfactory
            standard. This includes viewing all videos and making a genuine
            attempt at all questions. Except for the aforementioned guarantee,
            all course subscriptions are non-refundable.
          </p>
          <p className="font-light text-base text-[#4849A6] leading-6 mb-[10px]">
            <span className="font-bold">Standalone Content: </span>
            From time to time, ExamSolutions may offer standalone content for
            purchase. This content is non-refundable. Tutoring Services: We
            operate as an agency that matches tutors with students. Payments for
            lessons are made by clients to ExamSolutions, which are then
            remitted to tutors. If a lesson is cancelled by the client with less
            than 24 hours notice, they may be charged for the lesson.
          </p>
        </div>
        <div>
          <h3 className="font-bold text-base text-[#4849A6] leading-6 mb-[10px]">
            4. Resources & Liability
          </h3>
          <p className="font-light text-base text-[#4849A6] leading-6 mb-[10px]">
            {`Resources provided on the Site undergo checks for accuracy and
            dependability. However, the relevance or utility of these resources
            cannot be guaranteed. These resources should not be the primary
            source of any advice and must be used in conjunction with guidance
            from qualified professionals. Under no circumstance is ExamSolutions
            responsible or liable for exam results, academic performance, or the
            progression of individuals using the Site's resources, regardless of
            whether payment was made for these resources`}
            .
          </p>
        </div>
        <div>
          <h3 className="font-bold text-base text-[#4849A6] leading-6 mb-[10px]">
            5. Downloads & Refunds
          </h3>
          <p className="font-light text-base text-[#4849A6] leading-6 mb-[10px]">
            For downloadable resources available for purchase, a preview will be
            provided. Given the availability of these previews, refunds will not
            be provided for purchased resources under any circumstances.
          </p>
        </div>
        <div>
          <h3 className="font-bold text-base text-[#4849A6] leading-6 mb-[10px]">
            6. Content Use & Redistribution
          </h3>
          <p className="font-light text-base text-[#4849A6] leading-6 mb-[10px]">
            All resources on the Site, whether free or purchased, are for the
            personal and private use of the individual accessing them.
            Redistribution, including hosting on another website, sharing on
            social media, or any other form of dissemination, is strictly
            prohibited. Violators may face legal consequences. Linking to our
            resources from other websites is permissible; however, direct
            hosting of our content is not allowed. Any action that involves
            uploading our content to another platform, webpage, or social media
            is strictly forbidden and could result in legal action.
          </p>
        </div>
        <div>
          <h3 className="font-bold text-base text-[#4849A6] leading-6 mb-[10px]">
            7. Amendments
          </h3>
          <p className="font-light text-base text-[#4849A6] leading-6 mb-[10px]">
            ExamSolutions reserves the right to modify or update these Terms and
            Conditions at any time without prior notice. Users are encouraged to
            regularly review these terms to stay informed of any changes.
          </p>
        </div>
        <div>
          <h3 className="font-bold text-base text-[#4849A6] leading-6 mb-[10px]">
            8. Governing Law
          </h3>
          <p className="font-light text-base text-[#4849A6] leading-6 mb-[10px]">
            These Terms and Conditions shall be governed by the laws of England
            and any disputes will be decided only by the courts of England.
          </p>
        </div>
        <div>
          <h3 className="font-bold text-base text-[#4849A6] leading-6 mb-[10px]">
            9. Contact Information
          </h3>
          <p className="font-light text-base text-[#4849A6] leading-6 mb-[10px]">
            For any queries or concerns related to these Terms and Conditions,
            please contact us at info@examsolutions.net
          </p>
        </div>
        {/* Money Back Guarantee */}
        <div>
          <h3 className="font-bold text-base text-[#4849A6] leading-6 mb-[10px]">
            10. Money back guarantee clause
          </h3>
          <p className="font-light text-base text-[#4849A6] leading-6 mb-[10px]">
            {`We prioritize your active engagement over financial gain because
            we're confident that our platform can help you achieve exam
            success. All we require is that you make `}
            <span className="font-semibold">an attempt</span> at all interactive
            questions within your course.
          </p>
          <p className="font-light text-base text-[#4849A6] leading-6 mb-[10px]">
            {`Here are 2 examples of 'Having a go'. `}
            <span className="font-semibold">
              *Please click on each image for better resolution
            </span>
          </p>
          <p className="font-light text-base text-[#4849A6] leading-6 mb-[10px]">
            <span className="font-semibold">Student A</span>
            <br />
            Gets the 1st question correct, then struggles with the next question
            so clicks <span className="font-medium">{`'Skip to next'`}</span>.
          </p>
          <div className="w-full mb-[10px]">
            <ImageGallery images={studentImagesA} />
            {/* <div className="relative min-w-[200px] min-h-[300px]">
              <Image alt="terms-conditions-screen-1a" src={screen1a.src} fill />
            </div>

            <div className="relative">
              <Image alt="terms-conditions-screen-2a" src={screen1b.src} fill />
            </div> */}
          </div>
          <div className="flex gap-2 items-center mb-[20px]">
            <p className="font-light text-base text-[#4849A6] leading-6 mb-[10px]">
              We see this as an attempted question.
            </p>
            <CheckBoxCheckedGreen className="mb-[10px]" />
          </div>
          <p className="font-light text-base text-[#4849A6] leading-6 mb-[10px]">
            <span className="font-semibold">Student B</span>
            <br />
            {'Gets the 1st question incorrect, then selects '}
            <span className="font-semibold">{'NO'}</span>
            {` to 'Would you like to try again?'.`}
          </p>
          <div className="w-full mb-[10px]">
            <ImageGallery images={studentImagesB} />
            {/* <div className="relative min-w-[500px] min-h-[300px]">
              <Image alt="terms-conditions-screen-1a" src={screen2a.src} fill />
            </div>

            <div className="relative">
              <Image alt="terms-conditions-screen-2a" src={screen2b.src} fill />
            </div> */}
          </div>
          <div className="flex gap-2 items-center mb-[20px]">
            <p className="font-light text-base text-[#4849A6] leading-6 mb-[10px]">
              We see this as an attempted question
            </p>
            <CheckBoxCheckedGreen className="mb-[10px]" />
          </div>
          <p className="font-light text-base text-[#4849A6] leading-6 mb-[10px]">
            {`Per course, there are approximately 300-400 compulsory questions.
            When you answer a question correctly and we ask you to answer a
            harder question, this question is not compulsory. That's because we
            use Smart question matching to give you the right questions based on
            your Visely score.`}
          </p>
        </div>
      </div>
      <Footer />
    </>
  )
}
